var _circle, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlackDiamond(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.1667,
    fill: "black",
    stroke: "#8473FF",
    strokeWidth: 1.66667
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5378 11.2623L16.4886 7.48979C16.4412 7.40258 16.3694 7.32941 16.2809 7.27832C16.1924 7.22723 16.0907 7.2002 15.9871 7.2002H8.0367C7.93352 7.20019 7.83231 7.22697 7.74411 7.27762C7.6559 7.32827 7.58408 7.40084 7.53647 7.48743L5.46377 11.2567C5.40944 11.3554 5.38917 11.4678 5.4058 11.5781C5.42243 11.6883 5.47512 11.7909 5.55648 11.8714L11.5862 17.8355C11.6388 17.8875 11.702 17.9289 11.772 17.9572C11.842 17.9855 11.9173 18.0001 11.9934 18.0002C12.0694 18.0002 12.145 17.9856 12.215 17.9574C12.2849 17.9292 12.3481 17.8879 12.4008 17.836L18.4433 11.8752C18.5245 11.795 18.5773 11.6929 18.5942 11.5831C18.6112 11.4732 18.5915 11.3611 18.5378 11.2623ZM15.3311 11.8627L12.404 14.7502C12.3514 14.8021 12.2882 14.8434 12.2183 14.8717C12.1483 14.8999 12.0731 14.9144 11.997 14.9144C11.9209 14.9144 11.8452 14.8998 11.7753 14.8715C11.7053 14.8431 11.6421 14.8017 11.5895 14.7497L8.66865 11.8606C8.45343 11.6477 8.46141 11.3101 8.68649 11.1066C8.91156 10.903 9.26848 10.9105 9.48371 11.1234L11.9976 13.61L14.5171 11.1245C14.7327 10.9119 15.0896 10.9048 15.3144 11.1087C15.5391 11.3125 15.5467 11.6501 15.3311 11.8627Z",
    fill: "url(#paint0_linear_2794_1161)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2794_1161",
    x1: 14.4074,
    y1: 7.2002,
    x2: 11.4099,
    y2: 18.7027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDC9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.674158,
    stopColor: "#9190FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackDiamond);
export default __webpack_public_path__ + "static/media/black-diamond.svg";
export { ForwardRef as ReactComponent };